import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

const RETRY_KEY = 'auw_chunk_load_retry';

/**
 * 배포 후 stale chunk 404를 자동 복구하는 lazy wrapper.
 * 첫 번째 실패 → sessionStorage flag 저장 후 페이지 리로드 (새 index.html + 새 chunk 로드).
 * 두 번째 연속 실패 → flag 제거 후 에러를 다시 throw (AppErrorBoundary가 잡음).
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  importFn: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return lazy(() =>
    importFn().then(
      (module) => {
        if (typeof sessionStorage !== 'undefined') {
          sessionStorage.removeItem(RETRY_KEY);
        }
        return module;
      },
      (error: unknown) => {
        if (typeof sessionStorage === 'undefined') throw error;

        const hasRetried = sessionStorage.getItem(RETRY_KEY);
        if (!hasRetried) {
          sessionStorage.setItem(RETRY_KEY, '1');
          window.location.reload();
          return new Promise<never>(() => {});
        }

        sessionStorage.removeItem(RETRY_KEY);
        throw error;
      },
    ),
  );
}
